module.exports = __webpack_public_path__ + "img/qiyuan.9cd26f18.jpg";